import fetch from '@/utils/fetch';

// 查询配置信息
export function getPlatformConfig(params) {
    const currentHostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const preferredHostname = params?.hostname || params?.domain || currentHostname;
    const requestParams = {
        ...(params || {}),
        hostname: preferredHostname
    };
    return fetch({
        url: '/platform/config/selectConfigInfo',
        method: 'get',
        params: requestParams
    })
}

// 获取当前登入方式
export function getLoginMethod() {
    return fetch({
        url: '/platform/config/selectLoginMethod',
        method: 'get',
        headers: {
            isToken: false,
            ignore401: true
        }
    })
}